import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import derectives from './derectives'
// import './config/gtm/gtm.js'
import './config/metrika/metrika.js'

// import lodash from 'lodash'
import vmodal from 'vue-js-modal'
import VeeValidate from 'vee-validate';
import VueTheMask from 'vue-the-mask'
import vueTopprogress from 'vue-top-progress'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueMeta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script';
import $ from 'jquery'

// import firebaseConfig from './config/firebase'
// import firebase from 'firebase'

window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
var ionRangeSlider = require('ion-rangeslider');
var VueScrollTo = require('vue-scrollto');
// var VueCookie = require('vue-cookie');

// js libs
import 'bootstrap/dist/js/bootstrap.min.js'
// import 'ion-rangeslider/js/ion.rangeSlider.min.js'
// import './plugins/sharer.js'
// import './plugins/pinchzoomer/hammer.js'
// import './plugins/pinchzoomer/TweenMax.js'
// import './plugins/pinchzoomer/jquery.pinchzoomer.js'
// import 'selectric/public/jquery.selectric.min.js'
// css libs
import 'swiper/dist/css/swiper.css'
import 'ion-rangeslider/css/ion.rangeSlider.min.css'
// import 'selectric/public/themes/plus/selectric.css'

window.body = $('body');
window.url = 'https://dialgroup.kz/cms/';
window.mainUrl = 'https://dialgroup.kz';

window.JsonUrl = 'wp-json/acf/v3/';
window.GlobalLang = localStorage.getItem('languageDial');
window.LangVar = 'ru';

if (window.GlobalLang === null) {
  window.GlobalLang = 'kz/';
  window.LangVar = 'kz';
  setDataLang(window.GlobalLang);
} else if (window.GlobalLang === 'ru') {
  window.GlobalLang = '';
  window.LangVar = 'ru';
  setDataLang(window.GlobalLang);
} else if (window.GlobalLang == 'kz/') {
  window.LangVar = 'kz';
  setDataLang(window.GlobalLang);
} else {
  setDataLang(window.GlobalLang);
}

function setDataLang(lang) {
  if (lang = '') {
    document.querySelector('body').dataset.language = window.GlobalLang;
  } else {
    document.querySelector('body').dataset.language = window.GlobalLang.replace(/\/$/, "");
  }
}

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'ru',
  validity: false
};

const configScrollTo = {
  container: "body",
  duration: 1200,
  easing: "ease-in-out",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};

// firebase.initializeApp(firebaseConfig);

Vue.use(VueAwesomeSwiper);
Vue.use(VueTheMask);
Vue.use(vmodal);
Vue.use(vueTopprogress);
Vue.use(LoadScript);
Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueScrollTo, configScrollTo);
Vue.use(VueMeta);
// Vue.use(VueCookie);
// Vue.use(VueMasonryPlugin);
// Vue.use(VueMasonry);

new Vue({
  router,
  render: h => h(App),
  store,
  derectives,
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')